var handle_array = ["nardi-omega-outdoor-patio-chaise-lounge","nardi-4-piece-patio-set","nardi-5-pcs-outdoor-set","nardi-9-piece-libeccio-88-in-x-40-in-dining-table-with-bora-armchairs-display-model","nardi-alfa-3-piece-outdoor-patio-chaise-lounge-set","nardi-alfa-outdoor-patio-chaise-lounge","nardi-charcoal-aquamarina-5-position-patio-folding-chair","copy-of-nardi-bora-arm-patio-chairs","nardi-bit-outdoor-patio-chairs","nardi-bora-arm-patio-chairs","nardi-charcoal-delta-5-position-patio-folding-chair","nardi-costa-arm-outdoor-patio-chair","nardi-9-piece-libeccio-88-in-x-40-in-patio-dining-table-only","nardi-libeccio-replacement-parts-panel-only-patio","copy-of-nardi-bora-arm-patio-chairs-1","copy-of-nardi-4-piece-resin-patio-furniture-set","nardi-net-outdoor-indoor-patio-table","nardi-net-chair-outdoor-patio","nardi-net-relax-outdoor-patio-chair","nardi-riva-outdoor-patio-chair","nardi-rodi-patio-outdoor-side-table","nardi-trill-outdoor-patio-chair","vondom-outdoor-patio-head-end-table-black","emu-darwin-steel-indoor-outdoor-patio-chair-made-in-italy","nardi-folio-outdoor-patio-chair","nardi-bar-or-counter-patio-stools","nardi-libeccio-outdoor-patio-adjustable-dining-table-only","nardi-musa-patio-outdoor-chairs","nardi-doga-relax-indoor-outdoor-patio-chair-made-in-italy","nardi-net-lounge-indoor-outdoor-patio-chair","castello-outdoor-patio-arm-chair","sunset-rattan-arm-outdoor-patio-chair","nardi-outdoor-furniture-rio-bench-only","regeneration-patio-furniture"];
 var productid_array = ["5107148816517","5533002727585","6033136517281","6033165779105","7204808556705","6107466629281","6608996860065","6032352968865","5095323861125","7210672455841","6801779523745","6570435772577","7210639687841","7210619404449","7204850860193","6033225253025","6033231610017","6033162731681","7210669244577","7100763603105","7210649944225","6033211523233","7204783128737","7172414210209","6068068384929","7204817305761","7654907281569","7655193280673","7655189577889","7666516787361","7655210352801"];
 var collectionid_array = [""];
 var product_tags_array = [""];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '+16476998240';
 var display_call_for_price = 0;
 var call_for_price_label = 'Call for Discounted Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='.sca-qv-button';
  var phone_no_label = 'Call for Discounted Price';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 1;
 var whatsapp_number = '+16476998240';
 var whatsapp_message = 'Hi BigBaba.com I am interested in this product. {product_url}. Price please ?';
 var hide_whatsapp_button_on_collection = 1;
 var whatsapp_button_text ='Get price on WhatsApp';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';